import { ERROR_CODES } from 'common/constants'
import { tryCallApi } from 'common/helpers'
import { FixedAssetsService } from 'common/open-api'
import { getAxiosSilent } from 'common/open-api/helper'
import { useEffect, useState } from 'react'

// Whether the API allows correcting the fixed asset. Skips the request when disabled or without a biid;
// stays false until the request succeeds, and a failed request settles as false.
// isRetroActiveClosed flags the API rejecting with ERR_CORRECTION_MONTH_RETRO_ACTIVE_HAS_CLOSED.
// isCheckingCorrectable is true until the request for the current biid settles (already true on the first render).
export const useIsCorrectable = (biid?: string, enabled = true) => {
  const [isCorrectable, setIsCorrectable] = useState(false)
  const [isRetroActiveClosed, setIsRetroActiveClosed] = useState(false)
  const [checkedBiid, setCheckedBiid] = useState<string>()

  useEffect(() => {
    if (!enabled || !biid) return
    const checkCorrectable = async () => {
      const response = await tryCallApi(FixedAssetsService.getFixedAssetsByBiidIsCorrectable)(biid, getAxiosSilent())
      setIsCorrectable(Boolean(response.data?.data))
      setIsRetroActiveClosed(
        !!response.error?.response?.data?.errors?.some(
          (error: any) => error?.code === ERROR_CODES.ERR_CORRECTION_MONTH_RETRO_ACTIVE_HAS_CLOSED
        )
      )
      setCheckedBiid(biid)
    }

    checkCorrectable()
  }, [biid, enabled])

  return { isCorrectable, isRetroActiveClosed, isCheckingCorrectable: enabled && !!biid && checkedBiid !== biid }
}
